var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 4.125C44.265 4.125 55.875 15.735 55.875 30C55.875 44.265 44.265 55.875 30 55.875C15.735 55.875 4.125 44.265 4.125 30C4.125 15.735 15.735 4.125 30 4.125ZM30 0C13.4325 0 0 13.4325 0 30C0 46.5675 13.4325 60 30 60C46.5675 60 60 46.5675 60 30C60 13.4325 46.5675 0 30 0Z",
    fill: "white",
    fillOpacity: 0.95
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6018 37.6318L17.4296 37.8041C17.3734 37.8605 17.3289 37.9274 17.3008 38.0012L14.3727 45.6245C14.286 45.8414 14.3363 46.0901 14.5015 46.2566C14.6139 46.3693 14.7639 46.4279 14.9161 46.4279C14.9887 46.4279 15.0637 46.415 15.1328 46.3869L22.7459 43.4549C22.8736 43.4031 22.9767 43.3105 23.0411 43.1934C23.0551 43.1768 23.0727 43.1559 23.0938 43.1323L17.6018 37.6318Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1003 15.6074C43.9455 14.4498 41.6393 13.5702 40.4845 14.7278L38.7393 16.4729L44.2266 21.9676L45.9776 20.2471C47.1418 19.0801 46.2564 16.7637 45.1003 15.6074Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1045 19.1123L20.2388 34.9923L25.7085 40.4694C27.2639 38.8626 31.6163 34.4832 41.5872 24.6023L36.1045 19.1123Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5016 46.2569C14.336 46.0898 14.2864 45.8413 14.3722 45.6247L17.3012 37.9999C17.3288 37.9271 17.3738 37.8604 17.4303 37.8037L17.6019 37.6321L23.0947 43.132C23.0727 43.1552 23.0553 43.177 23.0406 43.1931C22.9768 43.3094 22.8736 43.4023 22.7456 43.4547L15.1326 46.3863C15.0642 46.4154 14.9885 46.4285 14.916 46.4285C14.7632 46.4285 14.6136 46.3688 14.5016 46.2569V46.2569ZM20.2386 34.9912L36.1046 19.1121L41.5869 24.6019C31.6162 34.4825 27.2632 38.8617 25.708 40.4678L20.2386 34.9912ZM38.7395 16.4726L40.4852 14.7284C41.6406 13.5699 43.9457 14.4494 45.1012 15.6077C46.257 16.7633 47.1418 19.08 45.9776 20.2472L44.2264 21.968L38.7395 16.4726Z",
    fill: "white",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileEditIcon);
export default __webpack_public_path__ + "static/media/profile-edit-icon.1532863a64fae053c6ca224bc804bc8b.svg";
export { ForwardRef as ReactComponent };